<template>
<div style="display: flex; flex-direction: column; gap: 10px;">
  <div v-for="(recipient, index) in recipientsListToDisplay" :key="recipient.name + index">
    <span v-for="(contact, index) in recipient.contacts" :key="contact.to + index">{{contact.to}}
      <span v-if="(index < recipient.contacts.length - 1) && (contact.to !== '')">;</span>
    </span>
    <span>{{recipient.name}}</span>
  </div>
  <button
    v-if="recipients.length > recipientsToDisplay"
    @click="displayMoreRecipients"
    style="align-self: left; cursor: pointer; width: fit-content;"
  >
    ...
  </button>
</div>
</template>

<script>
export default {
  name: 'MailingRecipientsListPreview',
  props: {
    recipients: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
      recipientsToDisplay: 5
    }
  },
  computed: {
    recipientsListToDisplay () {
      return this.recipients.slice(0, this.recipientsToDisplay)
    }
  },
  methods: {
    displayMoreRecipients () {
      this.recipientsToDisplay = this.recipientsToDisplay + 20
    }
  }
}
</script>
